module.exports = __webpack_public_path__ + "static/media/LJM_Developments_Stoney_Creek-Statement-of-Allegations-Summary.20d98077.pdf";